import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'twinkle-step-title',
  templateUrl: './step-title.component.html',
  styleUrls: ['./step-title.component.scss']
})
export class StepTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
